/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CmsComponent } from '../../../model/cms.model';
import { PageContext } from '../../../routing/index';
import { StateUtils } from '../../../state/utils/index';
import { COMPONENT_ENTITY } from '../cms-state';

export const LOAD_CMS_COMPONENT = '[Cms] Load Component';
export const LOAD_CMS_COMPONENT_FAIL = '[Cms] Load Component Fail';
export const LOAD_CMS_COMPONENT_SUCCESS = '[Cms] Load Component Success';
export const CMS_GET_COMPONENT_FROM_PAGE = '[Cms] Get Component from Page';

export class LoadCmsComponent extends StateUtils.EntityLoadAction {
  readonly type = LOAD_CMS_COMPONENT;
  constructor(
    public payload: {
      id: string;
      pageContext?: PageContext;
    }
  ) {
    super(COMPONENT_ENTITY, payload.id);
  }
}

export class LoadCmsComponentFail extends StateUtils.EntityFailAction {
  readonly type = LOAD_CMS_COMPONENT_FAIL;
  constructor(
    public payload: { id: string; error?: any; pageContext: PageContext }
  ) {
    super(COMPONENT_ENTITY, payload.id, payload.error);
  }
}

export class LoadCmsComponentSuccess<
  T extends CmsComponent
> extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_CMS_COMPONENT_SUCCESS;
  constructor(
    public payload: {
      component: T;
      id?: string;
      pageContext: PageContext;
    }
  ) {
    super(COMPONENT_ENTITY, payload.id || payload.component.id || '');
  }
}

export class CmsGetComponentFromPage<
  T extends CmsComponent
> extends StateUtils.EntitySuccessAction {
  readonly type = CMS_GET_COMPONENT_FROM_PAGE;
  constructor(
    public payload:
      | { component: T; pageContext: PageContext }
      | { component: T; pageContext: PageContext }[]
  ) {
    super(
      COMPONENT_ENTITY,
      ([] as any[]).concat(payload).map((cmp) => cmp.component.id)
    );
  }
}

// action types
export type CmsComponentAction<T extends CmsComponent> =
  | LoadCmsComponent
  | LoadCmsComponentFail
  | LoadCmsComponentSuccess<T>
  | CmsGetComponentFromPage<T>;
